import { debounceLiveViewPush } from '../helpers/utils'

type DetailsPayload = {
  id: string
}

export const FacadeDetails = {
  mounted() {
    const EVENT_ON_SHOW = this.el.dataset?.eventOnShow
    const EVENT_ON_HIDE = this.el.dataset?.eventOnHide
    const EVENT_PAYLOAD = { id: this.el.id }
    const TARGET = this.el.getAttribute('phx-target')

    // Create debounced push functions for show/hide events
    const debouncedShowPush = EVENT_ON_SHOW
      ? debounceLiveViewPush(this, EVENT_ON_SHOW, {
          waitMs: 300,
          timing: 'trailing',
          target: TARGET,
          errorMessage: 'Details show event failed'
        })
      : null

    const debouncedHidePush = EVENT_ON_HIDE
      ? debounceLiveViewPush(this, EVENT_ON_HIDE, {
          waitMs: 300,
          timing: 'trailing',
          target: TARGET,
          errorMessage: 'Details hide event failed'
        })
      : null

    const toggle = () => {
      // Use debounced LiveView push with built-in Sentry integration
      if (this.el.open && debouncedShowPush) {
        debouncedShowPush.execute(EVENT_PAYLOAD)
      } else if (!this.el.open && debouncedHidePush) {
        debouncedHidePush.execute(EVENT_PAYLOAD)
      }
      // No-op if no event configured - debouncedPush functions handle all errors internally
    }

    this.handleShow = (event: Event) => {
      if (this.el.id === (event.target as HTMLElement).id) {
        this.el.setAttribute('open', true)
      }
    }

    this.handleHide = (event: Event) => {
      if (this.el.id === (event.target as HTMLElement).id) {
        this.el.removeAttribute('open')
      }
    }

    window.addEventListener('details:show', this.handleShow)
    window.addEventListener('details:hide', this.handleHide)

    this.handleEvent('details:show', (payload: DetailsPayload) => {
      if (payload.id === this.el.id) {
        this.el.setAttribute('open', true)
      }
    })

    this.handleEvent('details:hide', (payload: DetailsPayload) => {
      if (payload.id === this.el.id) {
        this.el.removeAttribute('open')
      }
    })

    if (EVENT_ON_SHOW || EVENT_ON_HIDE) {
      this.el.addEventListener('toggle', toggle)
    }
  },

  destroyed() {
    window.removeEventListener('details:show', this.handleShow)
    window.removeEventListener('details:hide', this.handleHide)
  }
}
